var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('circle',{attrs:{"fill":"#50E3C2","cx":"10","cy":"10","r":"10","fill-rule":"evenodd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }